// ----------------------------------------------------------------------

const account = {
    displayName: 'Robert Ferrer',
    email: 'rferrer_5@hotmail.com',
    photoURL: '/static/mock-images/avatars/avatar_default.jpg'
};

export default account;
